import { render, staticRenderFns } from "./Certifications.vue?vue&type=template&id=0244fba2&scoped=true"
import script from "./Certifications.vue?vue&type=script&lang=js"
export * from "./Certifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0244fba2",
  null
  
)

export default component.exports